export default "__VITE_PUBLIC_ASSET__da8a870f__"